module.exports = __webpack_public_path__ + "img/points.8e4eeafe.svg";